import axios from 'lib/axios'

export const createStructureApi = async (building_id, data) => {
  return await axios.post(`/api/buildings/${building_id}/building_structures`, data)
}
